import { _extractAllAnnoBasedDimensionsAsOptions } from "./_extractAllAnnoBasedDimensionsAsOptions"
import { _extractOptionsFromContentTypes } from "./_extractOptionsFromContentTypes"
import { useGetQueryData } from "@/utils/react-query-hooks/general"
import { useGroupedSubThemeOptions } from "./useGroupedSubThemeOptions"
import { useTopicClusteringDimensionOptions } from "./useTopicClusteringDimensionOptions"
import { segrigateDocs } from "@okf/ootils"



export const useGetAllOptionsForDimension1 = ({showNumberInputsInOptions}) => {

    const allTpls = useGetQueryData('allTpls')
    const {SELF_MANAGED_BASE_CONFIGS, annotationTagsCount} = useGetQueryData('platformConfigs')

    const standardDocFieldsBasedOptions = _extractOptionsFromContentTypes({
      allTpls,
      contentTypes: allTpls.filter(tpl => tpl.general?.segment === 'publishing').map(d => d.kp_content_type),
      showNumberInputsInOptions
    })

    const smTagTypesConfig = SELF_MANAGED_BASE_CONFIGS?.annotation_tagTypesConfig || null;
    const {annoRollupOptions, annoTagOptions} = _extractAllAnnoBasedDimensionsAsOptions({
      allTpls,
      isSelfManagedTenant: SELF_MANAGED_BASE_CONFIGS.enable === true,
      annotationTagsCount,
      smTagTypesConfig,
    })

    // The grouped sub-theme options ("Life Skills & Leadership", ...) — shared
    // with dimension 2 and the other dimension slots via this hook.
    const groupedSubThemeOptions = useGroupedSubThemeOptions()
    const topicClusteringOptions = useTopicClusteringDimensionOptions()

    return ({
      options: [
        {
          display: 'Annotation Tags Based',
          options: [
            ...annoTagOptions,
            ...groupedSubThemeOptions,
            ...topicClusteringOptions,
            ...annoRollupOptions
          ]
        },
        ...Object.keys(segrigateDocs(standardDocFieldsBasedOptions || [], 'contentType')).map(ct => ({
          display: allTpls.find(tpl => tpl.kp_content_type === ct)?.general?.content?.title || ct,
          options: segrigateDocs(standardDocFieldsBasedOptions || [], 'contentType')[ct]
        }))

      ]
    })
  }
